import { Box } from '@mantine/core'
import dayjs from 'dayjs'

import Tag from 'src/components/DataDisplay/Tag/Tag'
import { useCallDrawerContext } from 'src/context/CallDrawerContext'
import IconRightArrow from 'src/icons/IconRightArrow'
import { formatSnakeValue } from 'src/lib/formatters'

const VoiceAgentAnalysisTable = ({ voiceAgentAnalysisResults }) => {
  const { handleOpen } = useCallDrawerContext()

  return (
    <div className="flex h-[445px] flex-col gap-2">
      {voiceAgentAnalysisResults.map((result) => (
        <Box
          key={result.id}
          className="flex flex-row items-center gap-2 rounded px-2 py-1 text-xs text-gray-500 hover:cursor-pointer hover:bg-doubleNickel-gray-50"
          onClick={() => handleOpen(result.activityLog.activityLogId)}
        >
          <div>{dayjs(result.createdAt).format('MM/DD/YYYY')}</div>
          <div>{dayjs(result.createdAt).format('HH:mm')}</div>
          <Tag
            showCloseButton={false}
            variant="error"
            size="xs"
            className="ml-auto"
          >
            {formatSnakeValue(result.name)}
          </Tag>
          <IconRightArrow className="h-3 w-3 fill-none stroke-doubleNickel-gray-700" />
        </Box>
      ))}
    </div>
  )
}

export default VoiceAgentAnalysisTable
